export class PhysicalCardProcessExternalResponseDto {
  processedCardOrdersCount: number;
  processBatchId: string;
}
